import React, {Component} from 'react'
import Axios from 'axios';
import './NewsDetail.css'
import {Link} from 'react-router-dom';
import {Breadcrumb, message} from 'antd'
import {data} from 'jquery';

export default class NewsDetail extends Component {

    state = {
        // NewsData: [],
        NewsData: {},
        relativeNewsData: [],
        id: 0,
        totalOfRelative: 0,//新闻相关的总数
    }

    componentDidMount() {
        const data = this.props.location.data
        const id = this.props.match.params.id
        console.log(id)

        // if (this.state.NewsData === [] || this.state.NewsData === undefined) {
        //     Axios.get(global.url.news + "news/selectOne/" + id)
        //         .then(res => {
        //             console.log(res.data)
        //             this.setState({
        //                 NewsData: res.data
        //             })
        //         })
        // }

        // this.setState({
        //     NewsData: data
        // })
        // Axios.get('../../data/Newsdata.json?id=' + id)

        Axios.get(global.url.news + "/news/selectOne/" + id)   //-- 换成我   获取详情新闻
            .then(res => {
                console.log("selectOne", res);
                if (res.data.code === "200" && res.data.payload) {
                    this.setState({
                        NewsData: res.data.payload    // -- 换成  把'[id]'给去掉
                    })
                } else {
                    message.error("新闻读取失败，请重新尝试！");
                }
            })

        // Axios.get('../../data/relativeNewsData.json')
        // http://192.168.158.13:9527/api/news-announcement/news/related?id=4&limit=4&page=1
        Axios.get(global.url.news + `/news/related?id=${id}&limit=4&page=1`)        // 获取相关新闻
            .then(res => {
                // debugger
                console.log("related", res);
                this.setState({
                    relativeNewsData: res.data.payload.records,
                    totalOfRelative: res.data.payload.total
                })
            })
    }

    changeRelativeNews = async () => {
        const id = this.props.match.params.id
        let num = Math.floor(this.state.totalOfRelative / 4)
        let pageNum = Math.floor(Math.random() * (num + 1))
        const {data: res} = await Axios.get(`${global.url.news}/news/related?id=${id}&limit=4&page=${pageNum}`)
        if (res.code === '200') {
            this.setState({
                relativeNewsData: res.payload.records
            })
        }
    }

    componentDidUpdate(newprops) {
        if (newprops.match.params.id !== this.props.match.params.id) {
            window.location.reload()
        }
    }

    render() {
        console.log("this.state.NewsData", this.state.NewsData);
        return (
            <div className='newsBox'>
                <div style={{height: '56px', width: '100%', paddingTop: '16px'}}>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <Link to={'/'}>首页</Link>
                            {/* <a href="#">首页</a> */}
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <Link to={'/NewsBulletin'}>新闻公告</Link>
                            {/* <a href='#'>新闻公告</a> */}
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            {this.state.NewsData.title}
                        </Breadcrumb.Item>
                    </Breadcrumb>
                </div>

                <div className="content_box">
                    <div className='News_margin News_article'>
                        <div className='NewsDetail_individual'>
                            <div
                                className='NewsDetail_individual_title News_title_margin'>{this.state.NewsData.title}</div>
                            {/*<div className='NewsDetail_individual_time'>{this.state.NewsData.created}</div>*/}
                            <div className='NewsDetail_individual_time'>{new Date(this.state.NewsData.created).toLocaleString().replace(/T/, ' ').replace(/\.\d+/, '')}</div>
                            <div className='NewsDetail_individual_tag_wrap'>
                                <div className='NewsDetail_individual_tag Tags_margin'
                                    style={{backgroundColor: this.state.NewsData.source == '1' ? '#53A9FF' : '#0072E5'}}>{this.state.NewsData.source == '1' ? '转载' : '自主'}</div>
                                <div className='NewsDetail_individual_tag Tags_margin News_title_author' style={{backgroundColor: this.state.NewsData.source == '1' ? '#53A9FF' : '#0072E5'}}>{this.state.NewsData.source == '1' ? '引用者':'作者'}: {this.state.NewsData.author}</div>
                            </div>
                            
                            {/* {this.state.NewsData.source == '1' ?
                            <div className='NewsDetail_individual_tag Tags_margin' style={{ backgroundColor: this.state.NewsData.source == '1' ? '#53A9FF' : '#0072E5' }}>
                                {this.state.NewsData.source == '1' ? '转载' : '自主'}
                            </div>
                        : null} */}
                            <div></div>
                            <div id="divider" className='News_title_margin News_margin'></div>
                        </div>
                        <div className='NewsDetail_summary'>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;{this.state.NewsData.summary}</p>
                        </div>
                        <div className='NewsDetail_content'
                             dangerouslySetInnerHTML={{__html: this.state.NewsData.content}}>
                        </div>
                        <div id="divider" className='News_title_margin News_margin'></div>
                        {/* <div className='NewsDetail_author'>编者：{this.state.NewsData.author}</div> */}
                    </div>

                    <div className='NewsDetail_more News_margin'>
                        <div className='NewsDetail_more_title'>
                            <div id='decorationBox' className='inline_box'></div>
                            <div onClick={() => this.changeRelativeNews()} className='NewsDetail_more_change'>换一批
                            </div>
                            <div className='NewsDetail_more_line'></div>
                        </div>

                        <div className='NewsDetail_more_news'>
                            {
                                this.state.relativeNewsData.map((data, index) => {
                                    let newsTag;
                                    let newsText;
                                    {
                                        if (data.source == '1') {
                                            newsTag = 'news_tag_self_transfer_detail';
                                            newsText = '转载'
                                        } else {
                                            newsTag = 'news_tag_self_detail';
                                            newsText = '自主'
                                        }
                                    }

                                    return (
                                        <Link to={`/NewsBulletin/NewsDetail/${data.id}`} key={data.id}>
                                            <div className='NewsDetail_more_newsbox'>
                                                <div className='NewsDetail_more_newsbox_title'>{data.title}</div>
                                                <span
                                                    className='NewsDetail_more_newsbox_time'>{data.created.slice(0, 10)}</span>
                                                <div className='NewsDetail_more_newsbox_content'>
                                                    <img className='NewsDetail_more_newsbox_newsPic'
                                                         src={data.thumbnail}></img>

                                                    <div className={newsTag}>{newsText}</div>
                                                    <div style={{
                                                        position: 'absolute',
                                                        backgroundColor: '#0072E5',
                                                        width: '100px',
                                                        height: '1px',
                                                        top: '52px',
                                                        right: '20px'
                                                    }}></div>
                                                    <div className="NewsDetail_more_newsbox_text_box">
                                                        <div className='NewsDetail_more_newsbox_text'>
                                                            <p>{data.summary}</p>
                                                        </div>
                                                        <Link className='NewsDetail_more_newsbox_details'
                                                              to={`/NewsBulletin/NewsDetail/${data.id}`}>
                                                            【详细】
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    )
                                })
                            }

                        </div>
                    </div>
                </div>
                <div style={{clear: 'both'}}></div>
                <div style={{display: 'block', height: '125px', width: '100%'}}></div>
            </div>
        )
    }
}
